import { InvoiceActionType } from "models/actionTypes/invoiceActionTypes";
import { ReduxConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const invoiceCreated = (invoice: WintSuperkollAPIModel.Invoice): InvoiceActionType => {
  return {
    type: ReduxConstants.InvoiceActions.INVOICE_CREATED,
    payload: invoice,
  };
};

export const invoiceUpdated = (invoice: WintSuperkollAPIModel.Invoice): InvoiceActionType => {
  return {
    type: ReduxConstants.InvoiceActions.INVOICE_UPDATED,
    payload: invoice,
  };
};

export const invoiceUpdatedContent = (invoice: WintSuperkollAPIModel.Invoice): InvoiceActionType => {
  return {
    type: ReduxConstants.InvoiceActions.INVOICE_UPDATED_CONTENT,
    payload: invoice,
  };
};

export const invoiceSent = (invoiceId: number): InvoiceActionType => {
  return {
    type: ReduxConstants.InvoiceActions.INVOICE_SENT,
    payload: invoiceId,
  };
};

export const invoiceDiscarded = (invoiceId: number): InvoiceActionType => {
  return {
    type: ReduxConstants.InvoiceActions.INVOICE_DISCARDED,
    payload: invoiceId,
  };
};

export const invoiceDueDateChangedToFutureDate = (invoiceId: number): InvoiceActionType => {
  return {
    type: ReduxConstants.InvoiceActions.INVOICE_DUE_DATE_CHANGED_TO_FUTURE_DATE,
    payload: invoiceId,
  };
};

export const invoiceDueDateChangedToPastDate = (invoice: WintSuperkollAPIModel.Invoice): InvoiceActionType => {
  return {
    type: ReduxConstants.InvoiceActions.INVVOICE_DUE_DATE_CHANGED_TO_PAST_DATE,
    payload: invoice,
  };
};

export const invoiceSnoozed = (invoiceId: number): InvoiceActionType => {
  return {
    type: ReduxConstants.InvoiceActions.INVOICE_SNOOZED,
    payload: invoiceId,
  };
};

export const invoiceReminderFeeWrittenOff = (invoiceId: number): InvoiceActionType => {
  return {
    type: ReduxConstants.InvoiceActions.INVOICE_REMINDER_FEE_WRITTEN_OFF,
    payload: invoiceId,
  };
};

export const invoiceCredited = (invoiceId: number): InvoiceActionType => {
  return {
    type: ReduxConstants.InvoiceActions.INVOICE_CREDITED,
    payload: invoiceId,
  };
};

export const invoiceAssignedNewOwnerMyself = (invoice: WintSuperkollAPIModel.Invoice): InvoiceActionType => {
  return {
    type: ReduxConstants.InvoiceActions.INVOICE_ASSIGNED_NEW_OWNER_MYSELF,
    payload: invoice,
  };
};

export const invoiceAssignedNewOwnerOthers = (invoiceId: number): InvoiceActionType => {
  return {
    type: ReduxConstants.InvoiceActions.INVOICE_ASSIGNED_NEW_OWNER_OTHERS,
    payload: invoiceId,
  };
};
